import * as React from 'react';
import { memo } from 'react';

const SvgNote = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 19 19", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M7.125 7.25h4.5M7.125 11.75h2.25M11.393 15.687H3.75a.563.563 0 0 1-.563-.562V3.875a.563.563 0 0 1 .563-.563H15a.563.563 0 0 1 .562.563v7.643a.556.556 0 0 1-.162.393l-3.614 3.614a.553.553 0 0 1-.393.162v0Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M15.513 11.75h-3.889v3.888", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgNote);

export { Memo as default };
